// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__15cXl","buttons":"PendingPaymentAlert_buttons__3sZiL"};